import { Component, OnInit } from '@angular/core';
import { RiskEvent } from "../../_interfaces/RiskEvent.model";
import { RepositoryService } from './../../shared/services/repository.service';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { RiskEventEditorComponent } from "../risk-event-editor/risk-event-editor.component";
import { RiskUser } from './../../_interfaces/RiskUser.model';


@Component({
  selector: 'app-my-risk-event-list',
  templateUrl: './my-risk-event-list.component.html',
  styleUrls: ['./my-risk-event-list.component.css']
})
export class MyRiskEventListComponent implements OnInit {
  public riskEvents: RiskEvent[];
  public user: RiskUser;

  closeResult: string;
  modalOptions: NgbModalOptions;

  constructor(private repository: RepositoryService,
    private modalService: NgbModal) {
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop'
    }
  }

  ngOnInit() {
    this.getAllRiskEvents();

    this.user = this.repository.GetMyUser();
  }

  public getAllRiskEvents() {
    let apiAddress: string = `RiskEvents`;
    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.riskEvents = res as RiskEvent[];
      });
  }

  open(content) {
    // const modal2Ref = this.modalService.open(RiskEventEditorComponent);
    // modal2Ref.componentInstance.my_modal_title = 'Add New Risk Event'
    const modal2Ref = this.modalService.open(RiskEventEditorComponent).result.then((result) => {
      this.getAllRiskEvents();
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public deleteRiskEvent(riskEventId: number) {
    let riskDetailUrl: string = `/myrisks/riskevents/${riskEventId}`; 
    this.repository.delete(riskDetailUrl)
      .subscribe(res => {
        // Update the page contents
        this.getAllRiskEvents();
      });
  }
  public getMessageFromChild(message: string) {
    if (message === 'refresh') {
      this.getAllRiskEvents();
    }
  }
}
